import React from 'react';
import axios from 'axios';
import apiUrls from "./config.js";

const LoggerComponent = () => {
  const sendDataToApi = (logData) => {
    axios.post(apiUrls.logs, logData)
      .then(response => {
        console.log('Log enviado con éxito:', response.data);
      })
      .catch(error => {
        console.error('Error al enviar el log:', error);
      });
  };

  return {
    sendDataToApi
  };
};

export default LoggerComponent;